import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Input, Button } from 'antd'
import { requiredMessage, inputPlace, successNotification, errorMessage, assignMessage } from '../../utils/helpers'
import { allPaths } from '../../utils/constants'
import { LoginHeader } from '../../Components'
import { ADMIN } from '../../utils/apis'
import axios from 'axios'
import { loginUser, removeUser } from '../../Redux/actions/authActions'
import EnglishLanguage from '../../Languages/EnglishLanguage.json'
import NlLanguage from '../../Languages/NetherlandsLanguage.json'
import WGP_logo_Text from '../../assets/WGP-white.png'

const AdminLogin = (props) => {
    const { language, selectedLanguage } = props
    const history = useHistory()
    const dispatch = useDispatch() 

    const [loading, setLoading] = useState(false)
    const onFinish = (value) => {
        setLoading(true)
        axios.post(ADMIN.LOGIN, value)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data.success) {
                    successNotification(selectedLanguage?.message_SuccessfullyLoggedIn)
                    dispatch(loginUser(data.admin))
                    return setTimeout(() => {
                        history?.replace(allPaths?.HOME)
                    }, 300)
                }
                else {
                    errorMessage(assignMessage(data.message, language?.language))
                }
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e.message, language?.language))
            })
    }

    useEffect(() => {
        dispatch(removeUser())
    }, [])

    return (
        <div>
            <LoginHeader />
            <div className='auth-screen-main-div-new sidebar-scroll_class'>
                <center>
                    <img src={WGP_logo_Text} className='img-for-login-page' />
                </center>
                <p className='heading head-center' style={{ color: 'white' }}>{selectedLanguage?.title_AdminLogin}</p>

                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                >
                    <div className='form-two-input-flex'>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='name'
                                label={<p className='p-admin-title-text'>{selectedLanguage?.title_Name}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.error_PleaseInputYourName
                                    }
                                ]}
                            >
                                <Input
                                    className='form-input-new-design-big-slam '
                                    placeholder={selectedLanguage?.placeHolder_InputYourNameHere}
                                />
                            </Form.Item>
                        </div>
                        <div className='form-two-input-flex-inner-input'>
                            <Form.Item
                                name='password'
                                label={<p className='p-admin-title-text'>{selectedLanguage?.label_Password}</p>}
                                rules={[
                                    {
                                        required: true,
                                        message: selectedLanguage?.error_PleaseEnterYourPassword
                                    },
                                    {
                                        min: 8,
                                        message: selectedLanguage?.error_PasswordMustBeAtLeastEightCharacters
                                    }
                                ]}
                            >
                                <Input.Password
                                    className='form-input-new-design-big-slam '
                                    placeholder={selectedLanguage?.PlaceHolder_PleaseEnterYourPasswordHere}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <Form.Item>
                        <Button
                            className='login-btn-height'
                            type='primary'
                            block
                            htmlType='submit'
                            loading={loading}
                        >
                            {selectedLanguage?.ButtonText_Submit}
                        </Button>
                        <div style={{ textAlign: 'center', marginTop: '20px', color: 'white' }}>
                            <p>{selectedLanguage?.minTitle_Gobackto}<Link className='linkStyle' to={allPaths?.LOGIN}> {selectedLanguage?.minTitle_Login}</Link>
                            </p>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default AdminLogin